import { render, staticRenderFns } from "./IconGrid.vue?vue&type=template&id=82f22c42&scoped=true&"
import script from "./IconGrid.vue?vue&type=script&lang=js&"
export * from "./IconGrid.vue?vue&type=script&lang=js&"
import style0 from "./IconGrid.vue?vue&type=style&index=0&id=82f22c42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f22c42",
  null
  
)

export default component.exports